export const STATUS_CODE = Object.freeze({
    UNAUTHORIZED: 401,
    FORBIDDEN: 403
});